<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="COMPANYEMAIL.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtEmail"
                formControlName="Naziv"
                #focusElement
                [MaxLength]="50"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'FIRMAEMAIL.NAZIV.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
                <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                  <span class="error-message" *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkEmail && !this.baseFormGroup.errors.checkEmail.valid"><span translate="{{this.baseFormGroup.errors.checkEmail.message}}"></span></span>
                </div>
            </div>
          </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="FIRMAEMAIL.GLAVNI.SINGULAR"></span></label>
          <div class="col-md-1">
            <input
              style="width: 20px;"
              type="checkbox"
              name="chkGlavni"
              class="form-control"
              formControlName="Glavni"
              autocomplete="off"
              >
          </div> -->
          <div class="col-md-12">
              <div class="form-check" style="padding-top: 22px">
                <input
                class="form-check-input" 
                type="checkbox"
                formControlName="Glavni"
                id="chkGlavni"
                >
                <label class="form-check-label" for="chkGlavni"><span translate="FIRMAEMAIL.GLAVNI.SINGULAR"></span></label>
              </div>
            </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="COMPANYEMAIL.SVOJINA.SINGULAR"></span></label> -->
          <div class="col-md-12">
              <yt-dropdown-picklist
                    [ModelName]="'svojina'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="SvojinaID"
                    [Label]="'FIRMAEMAIL.SVOJINA.SINGULAR'"
                    >
              </yt-dropdown-picklist>
              <!-- <yt-fw-dropdown
              [ModelName]="'svojina'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              [Required]='true'
              [Disabled]='false'
              formControlName="SvojinaID"
              name="cmbSvojina"
              [Type]="ID"
              [ngClass]="{'is-invalid': submitted && fc.SvojinaID.invalid}"
              [Label]="'COMPANYEMAIL.SVOJINA.SINGULA'">
            </yt-fw-dropdown> -->
            <div class="form-error" *ngIf="submitted && fc.SvojinaID.invalid">
                <span *ngFor="let validation of errorMessages.SvojinaID">
                  <span class="error-message" *ngIf="fc.SvojinaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="COMPANYEMAIL.OPIS.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtOpis"
              formControlName="Opis"
              [MaxLength]="100"
              [Label]="'FIRMAEMAIL.OPIS.SINGULAR'">
            </yt-input>
          </div>
        </div> 
      </div>
    </div>
  </div>
</form>
